import { TemperatureEquipment } from '../types/temperatureEquipment';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003/api';

const temperatureEquipmentApiService = {
  fetchByType: async (type: string): Promise<TemperatureEquipment[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/temperature-equipment?type=${type}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch temperature equipment');
      }

      return data.equipment;
    } catch (error) {
      console.error('Error fetching temperature equipment:', error);
      throw error;
    }
  },

  createEquipment: async (equipment: Partial<TemperatureEquipment>): Promise<TemperatureEquipment> => {
    try {
      const response = await fetch(`${API_BASE_URL}/temperature-equipment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(equipment),
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to create temperature equipment');
      }

      return data.equipment;
    } catch (error) {
      console.error('Error creating temperature equipment:', error);
      throw error;
    }
  },

  updateEquipment: async (id: string, equipment: Partial<TemperatureEquipment>): Promise<TemperatureEquipment> => {
    try {
      const response = await fetch(`${API_BASE_URL}/temperature-equipment/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(equipment),
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to update temperature equipment');
      }

      return data.equipment;
    } catch (error) {
      console.error('Error updating temperature equipment:', error);
      throw error;
    }
  },

  deactivateEquipment: async (id: string): Promise<void> => {
    try {
      const response = await fetch(`${API_BASE_URL}/temperature-equipment/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to deactivate temperature equipment');
      }
    } catch (error) {
      console.error('Error deactivating temperature equipment:', error);
      throw error;
    }
  },
};

export default temperatureEquipmentApiService;
